import instance from "../apis/axiosConfig";
// CREATE
export const createMachinery = (data) => {
  return instance.post("machinery/create", data);
};

// GET ALL
export const getMachineries = (page, limit) => {
  return instance.get(`machinery/getAll?page=${page}&limit=${limit}`);
};

// UPDATE DETAILS
export const updateMachinery = (id, data) => {
  return instance.post(`machinery/update/${id}`, data);
};

// DELETE
export const deleteMachinery = (id) => {
  return instance.delete(`machinery/delete/${id}`);
};

// UPDATE IMAGE
export const updateMachineryImage = (id, data) => {
  return instance.post(`machinery/update-image/${id}`, data);
};

// UPDATE PUBLISH STATUS
export const updatePublishStatus = (id, data) => {
  return instance.post(`machinery/update-publish-status/${id}`, data);
};

// UPDATE PRIORITY
export const updateMachineryPriority = (data) => {
  return instance.post("machinery/priority", data);
};